import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Contract } from '@app/features/contracts/contract.model';
import {
  acceptedDocumentsMimeTypes,
  DocumentTagAndId,
} from '@app/features/documents/document.model';
import { UploadDocumentButton } from '@app/features/documents/upload-document-button/upload-document-button';
import { createHateoasError } from '@app/shared/errors/error-modal/hateoas-error';
import { ErrorService } from '@app/shared/errors/error.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSignature } from '@fortawesome/free-solid-svg-icons';
import { SignatureService } from '../signature/signature-service';

@Component({
  selector: 'app-upload-signed-contract-button',
  imports: [UploadDocumentButton, FontAwesomeModule, MatTooltipModule],
  templateUrl: './upload-signed-contract-button.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./upload-signed-contract-button.scss'],
})
export class UploadSignedContractButton {
  acceptedImageMimeTypes = acceptedDocumentsMimeTypes;
  faSignature = faSignature;

  contractId = input.required<string>();
  contractUpdated = output<Contract>();

  signatureService = inject(SignatureService);
  errorService = inject(ErrorService);

  onDocumentUploaded(documentId: string) {
    const tagAndId: DocumentTagAndId = { tag: 'signedContract', id: documentId };
    this.signatureService.sign(this.contractId(), tagAndId).subscribe({
      next: (updatedContract) => {
        this.contractUpdated.emit(updatedContract);
      },
      error: (err) => {
        console.error('Error adding document to contract', err);
        this.errorService.makeErrorMessage(
          createHateoasError("Erreur lors de l'ajout du document au contrat", {
            errors: [err],
          }),
        );
      },
    });
  }
}
